import { Injectable } from "@angular/core";
import { CHttp } from "../../core/services/chttp.service";
import { config } from "../../app.config";

@Injectable()
export class JobCategoriesService {
  constructor(private http: CHttp) {}

  public getAllJobCategories() {
    return this.http.get(config.api_url + "job-categories");
  }

  public addJobCategory(name: any) {
    return this.http.post(config.api_url + "job-categories", name);
  }

  public deleteJobCategory(name: string) {
    return this.http.delete(config.api_url + "job-categories/" + name);
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/job-categories/services/job-categories.service.ts